import script from "./TotalCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalCard.vue?vue&type=script&setup=true&lang=js"

import "./TotalCard.vue?vue&type=style&index=0&id=17cca099&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17cca099"]])

export default __exports__